import { AfterContentInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";
import { HeroService } from "../../services/hero.service";
import { CustomValidators } from "../../validators/CustomValidators.validator";

@Component({
    selector: "app-home-page",
    templateUrl: "./home-page.component.html",
    styleUrls: ["./home-page.component.scss"]
})
export class HomePageComponent implements OnInit, AfterContentInit {
    public loggedIn: boolean = false;

    public form!: FormGroup;

    @ViewChild("hero", { static: true }) hero: ElementRef;

    constructor(
        public fb: FormBuilder,
        public heroService: HeroService,
        private analyticsHelper: AnalyticsHelperService
    ) {}

    ngOnInit(): void {
        this.form = this.fb.group(
            {
                user: this.fb.control("", [Validators.required, CustomValidators.user]),
                password: this.fb.control("", [Validators.required, CustomValidators.password])
            },
            { updateOn: "submit" }
        );

        this.analyticsHelper.trackPageLoad("homepage");
    }

    ngAfterContentInit() {
        this.heroService.setHero(this.hero);
    }

    public submitForm(valid: boolean) {
        if (valid) {
            this.loggedIn = true;
        } else {
            console.error("Sorry, your input is either invalid or incorrect");
        }
    }

    public track(id: string): void {
        this.analyticsHelper.trackInteraction(id);
    }
}
